import React from 'react';
import ReactDOM from 'react-dom/client';

/**
 * Simplified CSS Loading
 *
 * We're now using a simpler approach with hard-coded values in each component
 */

// Import our simplified CSS
import './styles/main.css';

// Import app-specific global styles
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Render when DOM is fully ready
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
